import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Import page components
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import HooksExtractorPage from './pages/HooksExtractorPage';
import CustomGptPage from './pages/CustomGptPage';
import WPPluginsPage from './pages/WPPluginsPage';

const App = () => {
  return (
    <div className="site-shell">
      <ScrollToTop />
      <Navigation />
      <main className="site-main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/tools/hooks-extractor" element={<HooksExtractorPage />} />
          <Route path="/tools/custom-gpt" element={<CustomGptPage />} />
          <Route path="/tools/wp-plugins" element={<WPPluginsPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
